import React from 'react';
import './View.css';

import camsNcpLogo from '../../images/cams-ncp-logo-placeholder.png';
import camsNcpDesign from '../../images/CamsNcp-image-design.png';
import euLogo from '../../images/cams-ncp-eu.png';
import copernicusLogo from '../../images/cams-ncp-copernicus.png';
import ecmwfLogo from '../../images/cams-ncp-ecmwf.png';
import camsLogo from '../../images/cams-ncp-cams.png';
import aemetLogo from '../../images/aemet_inst_pos_rgb.png';
import bscLogo from '../../images/cams-ncp-bsc-blue.png';

const CamsNcpView = () => {
  return (
    <div id="page-document" className="view-wrapper cams-ncp-view">
      <div className="cams-ncp-content">
        <h1 className="cams-ncp-title">CAMS NCP</h1>
        <div className="cams-ncp-intro">
          <img
            src={camsNcpLogo}
            alt="CAMS NCP Spain - Atmosphere Monitoring Service"
            className="cams-ncp-logo"
          />
          <p>
            El Servicio de Vigilancia de la Atmósfera de Copernicus – Programa
            de Colaboración Nacional (CAMS NCP) en España fomenta la adopción y
            adaptación de los productos del CAMS para alimentar los sistemas y
            servicios oficiales nacionales de información medioambiental y
            respaldar los mandatos oficiales de España relacionados con la
            gestión de la calidad del aire y la reducción de emisiones.
          </p>
        </div>
        <p>
          El proyecto garantiza un flujo bidireccional de datos e información
          con los usuarios finales, así como con otros servicios del CAMS, para,
          por un lado, apoyar y mejorar la comunicación de las actividades y
          productos del CAMS a las audiencias nacionales, regionales y locales
          españolas y, por otro lado, proporcionar retroalimentación al CAMS
          sobre sus productos, lo que a la larga puede contribuir a su mejora
          continua en el marco de otros servicios.
        </p>
        <p>
          CAMS NCP es una iniciativa liderada conjuntamente por el Barcelona
          Supercomputing Center-Centro de Supercomputación de Barcelona
          (BSC-CNS) y la{' '}
          <a
            href="https://www.aemet.es/es/portada"
            target="_blank"
            rel="noopener noreferrer"
          >
            Agencia Estatal de Meteorología (AEMET)
          </a>
          .
        </p>
        <div className="cams-ncp-design">
          <img
            src={camsNcpDesign}
            alt="CAMS para la gestión de la calidad del aire en España"
          />
        </div>
        <p>
          Si quieres saber más sobre el proyecto puedes acceder a la{' '}
          <a
            href="https://atmosphere.copernicus.eu/spain"
            target="_blank"
            rel="noopener noreferrer"
          >
            página principal de CAMS NCP
          </a>
          .
        </p>
        <p className="cams-ncp-footer-note">
          Este trabajo forma parte del Programa Nacional de Colaboración del
          CAMS. El Servicio de Vigilancia de la Atmósfera de Copernicus (CAMS)
          es gestionado por el ECMWF en nombre de la Comisión Europea.
        </p>
      </div>
      <div className="cams-ncp-funding">
        <img
          src={euLogo}
          alt="Programme of the European Union"
          className="cams-ncp-funding-logo cams-ncp-eu-logo"
        />
        <img
          src={copernicusLogo}
          alt="Copernicus"
          className="cams-ncp-funding-logo cams-ncp-copernicus-logo"
        />
        <img
          src={ecmwfLogo}
          alt="Implemented by ECMWF"
          className="cams-ncp-funding-logo cams-ncp-ecmwf-logo"
        />
        <img
          src={camsLogo}
          alt="Atmosphere Monitoring Service"
          className="cams-ncp-funding-logo cams-ncp-cams-logo"
        />
        <img
          src={aemetLogo}
          alt="Agencia Estatal de Meteorología"
          className="cams-ncp-funding-logo cams-ncp-partner-logo"
        />
        <img
          src={bscLogo}
          alt="Barcelona Supercomputing Center"
          className="cams-ncp-funding-logo cams-ncp-partner-logo"
        />
      </div>
    </div>
  );
};

export default CamsNcpView;
